import { render } from "./LeadEmail.vue?vue&type=template&id=670a2a6e&scoped=true&ts=true"
import script from "./LeadEmail.vue?vue&type=script&lang=ts"
export * from "./LeadEmail.vue?vue&type=script&lang=ts"

import "./LeadEmail.vue?vue&type=style&index=0&id=670a2a6e&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670a2a6e"]])

export default __exports__